// src/components/DefaultBanner.jsx
import React, { useEffect, useState } from "react";
import "./DefaultBanner.css";

const DefaultBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const closeBanner = () => setVisible(false);

  const visitYouTube = () => {
    window.open("https://youtube.com/shorts/BLNV8cGNQCU?feature=share", "_blank");
  };

  const downloadApp = () => {
    window.open("https://play.google.com/store/apps/details?id=com.trustapp", "_blank");
  };

  if (!visible) return null;

  return (
    <div className="job-banner-modal-backdrop">
      <div className="job-banner-modal-card">
        <button className="job-banner-modal-close-icon" onClick={closeBanner} aria-label="Close modal">
          &times;
        </button>
        <div className="job-banner-modal-header-icon">
          <i className="fas fa-search-location"></i>
        </div>
        <h2 className="job-banner-modal-title">Searching jobs or local staffs?</h2>
        <p className="job-banner-modal-description">
          Download the <strong>Trust App</strong> and tap the <span className="rocket-badge">🚀</span> icon in the bottom menu of the homepage to find self-employment and local job opportunities near you!
        </p>
        <div className="job-banner-modal-actions">
          <button className="job-banner-modal-btn-primary" onClick={downloadApp}>
            <i className="fab fa-android"></i> Download App
          </button>
          <button className="job-banner-modal-btn-secondary" onClick={visitYouTube}>
            <i className="fab fa-youtube"></i> Visit YouTube
          </button>
        </div>
      </div>
    </div>
  );
};

export default DefaultBanner;